import { ControlIcons } from 'owa-control-icons';
import loc from 'owa-localize';
import { getIsDarkTheme } from 'owa-fabric-theme';
import colorMap from './colorMap';
import { getPalette } from 'owa-theme';
import {
    changeBackgroundColor,
    hasSelectedProject,
    getBackgroundColor,
} from 'owa-timestream-store';
import type { IContextualMenuItem } from '@fluentui/react/lib/ContextualMenu';
import { noColorLabel } from './strings.locstring.json';

export default function getBackgroundColorMenuItems() {
    const isLightTheme = !getIsDarkTheme();
    const ringIconColor = getPalette().neutralTertiary;

    let colorMenu: IContextualMenuItem[] = [];
    const selectedColor = getBackgroundColor();

    let noColor = {
        color: 'None',
        textKey: noColorLabel,
        styleColor: '',
        showRing: true,
    };
    let backgroundColorList = [...colorMap, noColor];
    colorMenu = backgroundColorList.map(({ color, textKey, styleColor, showRing }) => {
        const useRingIcon = isLightTheme && !!showRing;
        return {
            key: color,
            text: loc(textKey),
            canCheck: true,
            checked: selectedColor === styleColor,
            onClick: onItemClicked,
            data: { color, styleColor },
            iconProps: {
                iconName: useRingIcon ? ControlIcons.CircleRing : ControlIcons.CircleFill,
            },
            itemProps: {
                styles: {
                    root: { outlineOffset: '-1px' },
                    icon: {
                        color: useRingIcon ? ringIconColor : styleColor,
                    },
                },
            },
        };
    });

    return colorMenu;
}

function onItemClicked(
    _?: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>,
    item?: IContextualMenuItem
) {
    if (item && hasSelectedProject?.()) {
        changeBackgroundColor(item.data.styleColor, item.data.color);
    }
}
